"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormDataBlobWithFile = exports.isFormValid = exports.processFormActions = exports.getFormDefaultState = void 0;

var _index = require("./index");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getFormDefaultState = function getFormDefaultState(fieldsTranspiler) {
  var fieldsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dataToStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    editable: false,
    // true, false
    storedData: dataToStore,
    fetchingData: false,
    savingData: false,
    fields: fieldsTranspiler(fieldsData)
  };
};

exports.getFormDefaultState = getFormDefaultState;

var processFormActions = function processFormActions(state, action, formName, dataTranspiler) {
  var newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case _index.FORM_SET_FIELD_VALUE:
      newState[action.formName]['fields'][action.fieldName]['value'] = action.value;
      return newState;

    case _index.FORM_SET_FIELD_VALIDATION:
      newState[action.formName]['fields'][action.fieldName]['valid'] = action.validationStatus;
      return newState;

    case _index.FORM_SET_EDITABLE_STATE:
      newState[action.formName]['editable'] = action.isEditable;
      return newState;

    case _index.FORM_DISCARD_CHANGES:
      newState[action.formName]['fields'] = dataTranspiler(newState[action.formName]['storedData']); // newState[action.formName]['savingData'] = false;

      return newState;

    case _index.FORM_FETCH_IN_PROGRESS:
      newState[action.formName]['fetchingData'] = true;
      return newState;

    case _index.FORM_SAVE_IN_PROGRESS:
      newState[action.formName]['savingData'] = true;
      return newState;

    case _index.FORM_FETCHING_ERROR:
      newState[action.formName]['fetchingData'] = false;
      return newState;

    case _index.FORM_SAVING_ERROR:
      newState[action.formName]['fields'] = action.resetForm ? dataTranspiler(newState[action.formName]['storedData']) : newState[action.formName]['fields'];
      newState[action.formName]['savingData'] = false;
      return newState;

    case _index.FORM_RECEIVE_DATA:
      newState[action.formName]['storedData'] = action.formData;
      newState[action.formName]['fields'] = dataTranspiler(action.formData);
      newState[action.formName]['fetchingData'] = false;
      return newState;

    case _index.FORM_SAVE_DATA:
      newState[action.formName]['storedData'] = action.formData;
      newState[action.formName]['fields'] = dataTranspiler(action.formData);
      newState[action.formName]['savingData'] = false;
      return newState;

    case _index.FORM_INVALIDATE_FIELDS:
      newState[action.formName]['savingData'] = false;
      newState[action.formName]['fields'] = invalidateFields(newState[action.formName]['fields']);
      return newState;

    case _index.FORM_RESET:
      newState[action.formName] = getFormDefaultState(dataTranspiler, {}, newState[action.formName]['storedData']);
      return newState;

    case _index.FORM_REPOPULATE:
      newState[action.formName] = getFormDefaultState(dataTranspiler, newState[action.formName]['storedData'], newState[action.formName]['storedData']);
      return newState;

    default:
      return state;
  }
};

exports.processFormActions = processFormActions;

var isFormValid = function isFormValid(fields) {
  for (var fieldName in fields) {
    if (!fields[fieldName]['valid']) return null;
  }

  return true;
};

exports.isFormValid = isFormValid;

var invalidateFields = function invalidateFields(fields) {
  var invalidatedFields = {};

  for (var _i = 0, _Object$entries = Object.entries(fields); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        fieldName = _Object$entries$_i[0],
        fieldStatus = _Object$entries$_i[1];

    var value = fieldStatus.value,
        valid = fieldStatus.valid;
    invalidatedFields[fieldName] = {
      value: value,
      valid: !!valid
    };
  }

  return invalidatedFields;
}; //this is used in paymentinfo component to create formData for backend calls


var createFormDataBlobWithFile = function createFormDataBlobWithFile(data) {
  var formData = new FormData();
  Object.keys(data).forEach(function (item) {
    if (!!data[item]) formData.append(item, data[item]);
  });
  return formData;
};

exports.createFormDataBlobWithFile = createFormDataBlobWithFile;